import { useEffect, useState } from "react";
import facilityThemeService from "../../services/facilityThemeService";
import { hslToHex } from "../../utils/colorConversion";
import { DEFAULT_THEME_CONFIG, BRANDING_SUMMARY_KEYS } from "../../constants/facility.constants";
import FacilityAvatar from "../shared/FacilityAvatar";

const BrandingTab = ({ facility, onReplaceLogo, onOpenThemeEditor }) => {
  const [themeConfig, setThemeConfig] = useState(DEFAULT_THEME_CONFIG);

  useEffect(() => {
    if (!facility?.facility_number) return;
    facilityThemeService
      .getFacilityThemeById(facility.facility_number)
      .then((data) => {
        if (data?.theme_config) setThemeConfig(data.theme_config);
      })
      .catch((error) => console.error("Error fetching facility theme:", error));
  }, [facility?.facility_number]);

  const summaryColors = BRANDING_SUMMARY_KEYS.map((key) => themeConfig.find((c) => c.color_key === key)).filter(Boolean);
  const logoUrl = facility?.logo_urls?.desktop_app_logo || facility?.logo_urls?.light_theme_logo;

  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h3 className="text-base font-bold text-gray-900">Branding</h3>
          <p className="text-sm text-gray-500">Logo and theme colors applied to this facility</p>
        </div>
        <button
          type="button"
          onClick={onOpenThemeEditor}
          className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
        >
          Open theme editor
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded-xl border border-gray-100 p-5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">Facility logo</p>
          <div className="flex items-center gap-4">
            <FacilityAvatar name={facility?.name} logoUrl={logoUrl} size="h-14 w-14" />
            <button type="button" onClick={onReplaceLogo} className="text-left">
              <span className="block text-sm font-semibold text-[#2B3674] hover:underline">Replace logo</span>
              <span className="text-xs text-gray-400">SVG or PNG, min 128x128</span>
            </button>
          </div>
        </div>

        <div className="rounded-xl border border-gray-100 p-5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">Theme colors</p>
          <div className="grid grid-cols-2 gap-3">
            {summaryColors.map((color) => {
              const hex = hslToHex(color.color_value);
              return (
                <div key={color.color_key} className="flex items-center gap-2">
                  <span className="h-8 w-8 flex-shrink-0 rounded-lg border border-gray-200" style={{ backgroundColor: hex }} />
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-gray-800">{color.display_name}</p>
                    <p className="text-xs text-gray-400">{hex}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandingTab;
